import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, icon, color = 'primary', loading = false }) => {
  const colorMap = {
    primary: 'bg-primary/10 text-primary',
    green: 'bg-green-100 text-green-600',
    blue: 'bg-blue-100 text-blue-600',
    orange: 'bg-orange-100 text-orange-600',
    purple: 'bg-purple-100 text-purple-600',
  };

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm text-muted-foreground font-medium">{title}</p>
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${colorMap?.[color] || colorMap?.primary}`}>
          <Icon name={icon} size={18} />
        </div>
      </div>
      {loading ? (
        <div className="h-8 w-16 bg-muted animate-pulse rounded" />
      ) : (
        <p className="text-2xl font-heading font-bold text-foreground">{value}</p>
      )}
    </div>
  );
};

export default StatsCard;
